<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý danh sách địa điểm</span></h3>
            </div>
            <div class="card-body">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                        <label>Tên địa điểm:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Tên địa điểm..." v-model="search.cTen" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                        <label>Trạng thái:</label>
                        <el-row :gutter="10">
                            <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                                    <el-option label="Tất cả" value="" selected></el-option>
                                    <el-option label="Hoạt động" value="1" selected></el-option>
                                    <el-option label="Đã xóa" value="0" selected></el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                                        class="fa fa-search"></i></el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">
            <div class="card-header py-3">
                <div class="body-function">
                    <div class="col-md-6">
                        <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd"
                            data-bs-toggle="modal" data-bs-target="#modal_hotline" :disabled="!handleCheckPerms('za:map:add')">
                            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                            <span class="btn-inner--text">&nbsp;Thêm địa điểm </span>
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="col-md-12 tbl">
                    <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%"
                        height="100%" fit stripe highlight-current-row>
                        <el-table-column prop="nMa" label="Mã" width="100" align="center"></el-table-column>
                        <el-table-column prop="cTen" label="Tên nhóm địa điểm" min-width="150" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="nThuTu" label="Thứ tự hiển thị" width="150" header-align="center" align="center"></el-table-column>
                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120">
                            <template #default="scope">
                                {{ momentDate(scope.row.dNgayTao) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="Trạng thái" width="120" align="center">
                            <template #default="scope">
                                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt Động</el-tag>
                                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
                            </template>
                        </el-table-column>
                        <!-- Button hành động -->
                        <el-table-column width="150" label="Hành động" align="center">
                            <template #default="scope">

                                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0 || !handleCheckPerms('za:map:edit')"
                                    @click="handleOpenEdit(scope.row)" data-bs-toggle="modal"
                                    data-bs-target="#modal_hotline">
                                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                                </el-button>

                                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0 || !handleCheckPerms('za:map:delete')"
                                    v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize">
                </el-pagination>
            </div>
        </div>

        <div class="modal fade" id="modal_hotline" ref="hotlineModalRef" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered mw-950px">
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header" id="modal_hotline_header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bolder">{{ !operation ? "Thêm địa điểm " : "Cập nhật địa điểm " }}</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                            @click="handleClose">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <div class="modal-body">
                        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px" class=" d-flex flex-column">
                            <el-form-item label="Tên nhóm địa điểm" prop="cTen">
                                <el-input v-model="formData.cTen" />
                            </el-form-item>
                            <el-form-item label="Thứ tự hiển thị" prop="nThuTu">
                                <el-input type="number" min="0" v-model="formData.nThuTu" />
                            </el-form-item>


                            <el-form-item label="Danh sách địa điểm">
                                <div class="w-100">
                                    <div v-for="(location, index) in formData.danhSachDiaDiem" :key="index" class="mb-3 p-3 border rounded">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <span class="fw-bold">Danh sách #{{ index + 1 }}</span>
                                            <el-button 
                                                plain 
                                                type="danger" 
                                                size="small"
                                                :disabled="formData.danhSachDiaDiem.length === 1"
                                                @click="handleRemoveLocation(index)">
                                                <i class="fas fa-trash"></i> Xóa
                                            </el-button>
                                        </div>
                                        <QuillEditor 
                                            class="w-100 d-flex flex-column" 
                                            :ref="`quillEditor_${index}`"
                                            @text-change="onTextChange(index)" 
                                            :options="quillOptions" />
                                    </div>
                                    <el-button 
                                        plain 
                                        type="primary" 
                                        @click="handleAddLocation"
                                        class="w-100 mt-2">
                                        <i class="fas fa-plus"></i> Thêm danh sách địa điểm
                                    </el-button>
                                </div>
                            </el-form-item>

                        </el-form>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Thêm</el-button>
                            <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Lưu</el-button>
                            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ZaMap } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
import { CookieComponent } from "@/assets/ts/components";
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';


export default {
    name: 'za-map',
    components: {
        QuillEditor
    },
    data() {
        return {
            perms: CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions")) : [], 
            search: {
                cTen: "",
            },
            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1
            },
            formData: {
                cTen: "",
                nTinhTrang: 1,
                danhSachDiaDiem: [{ cTen: "" }]
            },
            rules: {
                cTen: [{ required: true, message: "Xin vui lòng điền tên", trigger: "blur" }],
                nThuTu: [{ required: true, message: "Xin vui lòng điền thứ tự hiển thị", trigger: "blur" }],
            },
            tableData: { content: [] },
            isLoading: false,
            modalVisible: false,
            operation: false,
            iframeURL: "",
            openIframe: false,
            isSearchLoading: false,
            store: useStore(),
            quillOptions: {
                theme: 'snow',
                modules: {
                toolbar: {
                    container: [
                    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    ["image", "link"], ["clean"],
                    ],
                }
                }
            },
        }
    },
    methods: {
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleOpenAdd() {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = false
            this.formData = {
                cTen: "",
                nTinhTrang: 1,
                danhSachDiaDiem: [{ cTen: "" }]
            }
            this.$nextTick(() => {
                if (this.$refs.quillEditor_0 && this.$refs.quillEditor_0.length) {
                    this.$refs.quillEditor_0[0].setHTML("")
                }
            })
        },
        handleOpenEdit(val) {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = true
            this.formData = Object.assign({}, val)
            // Nếu danhSachDiaDiem không tồn tại, khởi tạo với cTen cũ
            if (!this.formData.danhSachDiaDiem || this.formData.danhSachDiaDiem.length === 0) {
                this.formData.danhSachDiaDiem = [{ cTen: val.cTen || "" }]
            }
            this.$nextTick(() => {
                this.formData.danhSachDiaDiem.forEach((item, index) => {
                    if (this.$refs[`quillEditor_${index}`] && this.$refs[`quillEditor_${index}`].length) {
                        this.$refs[`quillEditor_${index}`][0].setHTML(item.cTen || "")
                    }
                })
            })
        },
        handleClose() {
            this.$refs.formData.resetFields()
            this.modalVisible = false
            hideModal(this.$refs.hotlineModalRef)
        },
        handleDelete(val) {
            this.$confirm("Bạn có muốn xóa bản ghi này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    this.store.dispatch(ZaMap.delete, val).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: "Xóa bản ghi thành công", type: "success" });
                            this.handleFindPage()
                        } else {
                            ElMessage({ message: res.msg, type: "error" });
                        }
                    }).catch((error) => {
                        ElMessage({ message: "Xóa bản ghi thất bại", type: "error" });
                    })
                }).catch(() => {

                })
        },
        handleFindPage() {
            this.pageRequest.columnFilters = {
                cTen: {value:this.search.cTen},
                nTinhTrang: {value:this.search.nTinhTrang},
            }
            this.store.dispatch(ZaMap.findPage, this.pageRequest).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm địa điểm thất bại", type: "error" });
            })
        },
        handleSave() {
            this.$refs.formData.validate((valid) => {
                if (valid)
                    this.$confirm("Bạn có muốn lưu bản ghi này không?", "Xác nhận", {
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                        type: "warning",
                    })
                        .then(() => {
                            const data = Object.assign({}, this.formData);
                            this.store.dispatch(ZaMap.save, data).then(res => {
                                if (res.code == 200) {
                                    ElMessage({ message: this.operation ? "Cập nhật địa điểm thành công" : "Thêm địa điểm thành công", type: "success" });
                                    this.handleClose()
                                    this.handleFindPage()
                                }
                                else {
                                    ElMessage({ message: res.msg, type: "error" });
                                }
                            }).catch((error) => {
                                ElMessage({ message: this.operation ? "Cập nhật địa điểm thất bại" : "Thêm địa điểm thât bại", type: "error" });
                            })

                        }).catch(() => {

                        })
            })
        },
        onTextChange(index) {
            if (this.$refs[`quillEditor_${index}`] && this.$refs[`quillEditor_${index}`].length) {
                this.formData.danhSachDiaDiem[index].cTen = this.$refs[`quillEditor_${index}`][0].getHTML()
            }
        },
        handleAddLocation() {
            this.formData.danhSachDiaDiem.push({ cTen: "" })
        },
        handleRemoveLocation(index) {
            if (this.formData.danhSachDiaDiem.length > 1) {
                this.formData.danhSachDiaDiem.splice(index, 1)
            }
        },


        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        },
        handleCheckPerms(val){
            return this.perms.includes(val)
        }
    },
    mounted() {
        this.handleFindPage()
    }
};
</script>
<style lang="scss"></style>